module.exports = __webpack_public_path__ + "img/img11.b5d4edaf.png";